<template>
  <v-list-item
    v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}"
  >
    <v-list-item-content>
      <v-list-item-title>{{ item.supplier.name }} </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action
      v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0"
    >
      <entity-table-row-end-action-menu :actions="item.rowActions" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';

export default {
  name: 'SupplierListItem',
  components: { EntityTableRowEndActionMenu },
  props: {
    item: {
      type: Object,
      required: true,
      validator: (item) => {
        return !!item.supplier;
      },
    },
    showActions: {
      type: Boolean,
    },
    rowClickEnabled: {
      type: Boolean,
    },
  },
  methods: {},
};
</script>

<style scoped></style>
